import React from "react";
import styles from "./KeySpec.module.scss";

const KeySpec = ({ product }) => {
  const { Disclaimer } = product;
  return (
    <>
      <div className={styles.productDescription}>
          <p>{product.Description}</p>
      </div>
      {Disclaimer && (
        <div className={styles.productDisclaimer}>
          <li>ปฏิเสธ</li>
          <li>{Disclaimer}</li>
        </div>
      )}
    </>
  );
};

export { KeySpec };
